<template>
  <div class="ControlsTexture__Container">
    <div class="ControlsTexture__Item">
      <div class="ControlsTexture__Index">
        <p
          class="ControlsTexture__Index_text"
          :style="highlightedPt === 0 ? { 'font-weight': 600 } : { 'font-weight': 300 }"
        >
          A
        </p>
      </div>
      <div class="ControlsTexture__Slider">
        <input
          type="range"
          ref="slider01"
          step="0.01"
          min="0"
          max="1"
          v-model="s01"
          :style="gradientS01"
          @input="ValueChanged(0)"
        >
      </div>
      <div class="ControlsTexture__Value">
        <p
          class="ControlsTexture__Value_text"
          :style="highlightedPt === 0 ? { 'font-weight': 600 } : { 'font-weight': 300 }"
        >
          {{ s01trim }}
        </p>
      </div>
      <!--
      <div
        class="ControlsTexture__PinContainer"
        @click="PlacePin(0)"
        :style="selectedPt === 0 ? { background: 'black' } : { background: 'white'}"
      >
        <div
          class="ControlsTexture__Pin"
          :style="selectedPt === 0 ? { background: 'white' } : { background: 'black' }"
        />
      </div>
      -->
    </div>
    <div class="ControlsTexture__Item">
      <div class="ControlsTexture__Index">
        <p
          class="ControlsTexture__Index_text"
          :style="highlightedPt === 1 ? { 'font-weight': 600 } : { 'font-weight': 300 }"
        >
          B
        </p>
      </div>
      <div class="ControlsTexture__Slider">
        <input
          type="range"
          ref="slider02"
          step="0.01"
          min="0"
          max="1"
          v-model="s02"
          :style="gradientS02"
          @input="ValueChanged(1)"
        >
      </div>
      <div class="ControlsTexture__Value">
        <p
          class="ControlsTexture__Value_text"
          :style="highlightedPt === 1 ? { 'font-weight': 600 } : { 'font-weight': 300 }"
        >
          {{ s02trim }}
        </p>
      </div>
      <!--
      <div
        class="ControlsTexture__PinContainer"
        @click="PlacePin(1)"
        :style="selectedPt === 1 ? { background: 'black' } : { background: 'white'}"
      >
        <div
          class="ControlsTexture__Pin"
          :style="selectedPt === 1 ? { background: 'white' } : { background: 'black' }"
        />
      </div>
      -->
    </div>
    <div class="ControlsTexture__Item">
      <div class="ControlsTexture__Index">
        <p
          class="ControlsTexture__Index_text"
          :style="highlightedPt === 2 ? { 'font-weight': 600 } : { 'font-weight': 300 }"
        >
          C
        </p>
      </div>
      <div class="ControlsTexture__Slider">
        <input
          type="range"
          ref="slider03"
          step="0.01"
          min="0"
          max="1"
          v-model="s03"
          :style="gradientS03"
          @input="ValueChanged(2)"
        >
      </div>
      <div class="ControlsTexture__Value">
        <p
          class="ControlsTexture__Value_text"
          :style="highlightedPt === 2 ? { 'font-weight': 600 } : { 'font-weight': 300 }"
        >
          {{ s03trim }}
        </p>
      </div>
      <!--
      <div
        class="ControlsTexture__PinContainer"
        @click="PlacePin(2)"
        :style="selectedPt === 2 ? { background: 'black' } : { background: 'white'}"
      >
        <div
          class="ControlsTexture__Pin"
          :style="selectedPt === 2 ? { background: 'white' } : { background: 'black' }"
        />
      </div>
      -->
    </div>
    <div
      class="Buttons__Container"
    >
      <div
        class="Buttons__Left"
        @click="Reset()"
      >
        <p class="Buttons__Left__Text">
          {{ $t('button-reset') }}
        </p>
      </div>
      <div class="Buttons__Spacing" />
      <div
        class="Buttons__Right"
        @click="NextStep()"
      >
        <p class="Buttons__Right__Text">
          {{ $t('button-validate') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'

export default {
  data () {
    return {
      s01: 0,
      s02: 0,
      s03: 0
    }
  },
  computed: {
    ...mapGetters(['selectedPt', 'highlightedPt', 'force01', 'force02', 'force03', 'table']),
    s01trim () {
      return (Math.round(this.s01 * 100) / 100).toFixed(2)
    },
    s02trim () {
      return (Math.round(this.s02 * 100) / 100).toFixed(2)
    },
    s03trim () {
      return (Math.round(this.s03 * 100) / 100).toFixed(2)
    },
    gradientS01 () {
      return (this.GetSliderStyling(this.s01, 0))
    },
    gradientS02 () {
      return (this.GetSliderStyling(this.s02, 1))
    },
    gradientS03 () {
      return (this.GetSliderStyling(this.s03, 2))
    }
  },
  watch: {
    force01 () {
      this.$refs.slider01.value = this.force01
      this.s01 = this.force01
    },
    force02 () {
      this.$refs.slider02.value = this.force02
      this.s02 = this.force02
    },
    force03 () {
      this.$refs.slider03.value = this.force03
      this.s03 = this.force03
    }
  },
  mounted () {
    this.$refs.slider01.value = (this.force01 || 0)
    this.$refs.slider02.value = (this.force02 || 0)
    this.$refs.slider03.value = (this.force03 || 0)
    this.s01 = (this.force01 || 0)
    this.s02 = (this.force02 || 0)
    this.s03 = (this.force03 || 0)
  },
  methods: {
    GetSliderStyling (value, index) {
      const val = (parseFloat(value)) * 100
      const col = this.highlightedPt === index ? 'rgba(255, 179, 0)' : 'black'
      return { background: 'linear-gradient(to right, ' + col + ' 0%,' + col + ' ' + val + '%, #ebebeb ' + val + '%, #ebebeb 100%)' }
    },
    ValueChanged (index) {
      this.$store.dispatch('SetHighlightedPt', index)
      this.$store.dispatch('SetForces', [this.s01, this.s02, this.s03])
    },
    PlacePin (index) {
      if (this.selectedPt === index) {
        this.$store.dispatch('SetSelectedPt', -1)
      } else {
        this.$store.dispatch('SetSelectedPt', index)
      }
    },
    NextStep () {
      EventBus.$emit('NextStep')
    },
    Reset () {
      this.$refs.slider01.value = 0
      this.$refs.slider02.value = 0
      this.$refs.slider03.value = 0
      this.s01 = 0
      this.s02 = 0
      this.s03 = 0
      this.$store.dispatch('SetForces', [0, 0, 0])
      this.$store.dispatch('SetUVs', [this.table.defaultUV[0], this.table.defaultUV[1], this.table.defaultUV[2], this.table.defaultUV[3], this.table.defaultUV[4], this.table.defaultUV[5]])
    }
  }
}
</script>

<style scoped lang="scss">
.ControlsTexture__Container {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.ControlsTexture__Item {
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  margin-top: 10px;
}

.ControlsTexture__Slider {
  height: 100%;
  width: 90%;
  display: flex;
  justify-content: center;
}

.ControlsTexture__Index {
  width: 20px;
  display: flex;
}

.ControlsTexture__Value {
  width: 40px;
  display: flex;
}

@media screen and (min-width: 1300px) {

.ControlsTexture__Value_text {
  margin: auto;
  margin-right: 0;
  font-size: 1em;
}
.ControlsTexture__Index_text {
  margin: auto;
  margin-left: 0;
  font-size: 1em;
}

}

@media screen and (max-width: 1300px) {

.ControlsTexture__Value_text {
  margin: auto;
  margin-right: 0;
  font-size: 0.8em;
}
.ControlsTexture__Index_text {
  margin: auto;
  margin-left: 0;
  font-size: 0.8em;
}

}

.ControlsTexture__PinContainer {
  width: 30px;
  display: flex;
  border-radius: 3px;
}

.ControlsTexture__Pin {
    margin: auto;
    width: 15px;
    height: 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    background: black;
    pointer-events: auto;
    mask-image: url('../../../assets/icons/pushpin.svg');
}

input[type=range]:active {
  &::-webkit-slider-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-moz-range-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-ms-thumb {
    background:rgba(255, 179, 0, 1);
  }
}

input[type=range]:hover {
  &::-webkit-slider-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-moz-range-thumb {
    background:rgba(255, 179, 0, 1);
  }
  &::-ms-thumb {
    background:rgba(255, 179, 0, 1);
  }
}

input[type=range] {
  width: 100%;
  margin: 4.4px 0;
  background-color: transparent;
  height: 2px;
  align-self: center;
  -webkit-appearance: none;
  display: flex;
  justify-content:center;
}
input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
background: rgba(0,0,0,0)
}

input[type=range]::-moz-range-track {
background: rgba(0,0,0,0)
}

input[type=range]::-ms-track {
background: rgba(0,0,0,0)
}

input[type=range]::-webkit-slider-thumb {
  align-self: center;
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type=range]::-moz-range-thumb {
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type=range]::-ms-thumb {
  width: 11px;
  height: 11px;
  background: #000000;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}

.Buttons__Container {
 width: 100%;
 height: 38px;
 display: flex;
 flex-direction: row;
}

.Buttons__Left{
   width: 50%;
   display: flex;
   justify-content: center;
   border: 1px grey solid;
   border-radius: 50px;
}

.Buttons__Right{
  width: 50%;
  display: flex;
  justify-content: center;
  background: black;
  border-radius: 50px;
}

.Buttons__Left__Text {
 margin: auto;
 font-weight: 200;
 font-size: 0.9em;
}

.Buttons__Right__Text {
 color: white;
 margin: auto;
 font-size: 0.9em;
}

.Buttons__Spacing {
  width: 10px;
}
</style>
